import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import SimilarBroadcasts from 'components/SimilarBroadcasts/SimilarBroadcasts';
import routeDefinitions from 'enum/routeDefinitions';
import { generateID } from 'utils/helpers';

import styles from './DesktopBroadcastDisconnected.css';


const IDS = {
  prefix: 'TdHuU3pm',
  element: 'SimilarBroadcastsDesktop',
  moreCams: 'moreCams',
};

const makeId = generateID(IDS.prefix, IDS.element);
function DesktopBroadcastDisconnected({ user, embedProfileV2 }) {
  return (
    <div className={styles.offlineWrapper}>
      <div className={styles.camsWrapper}>
        <p>{translate('v2profile.shows.over')}</p>
        {!embedProfileV2 && (
          <Fragment>
            <SimilarBroadcasts user={user} />
            <Link
              className={styles.backToDirectory}
              id={makeId(IDS.moreCams)}
              to={routeDefinitions.root}
            >
              {translate('v2profile.view.more.cams')}
            </Link>
          </Fragment>
        )}
      </div>
    </div>
  );
}

DesktopBroadcastDisconnected.propTypes = {
  user: PropTypes.object.isRequired,
  embedProfileV2: PropTypes.bool,
};

DesktopBroadcastDisconnected.defaultProps = { embedProfileV2: false };

export default observer(DesktopBroadcastDisconnected);
